// extracted by mini-css-extract-plugin
export default {"audio":"audioButton_audio__FPnh6"};